import { tr } from "@/utils/translations";
import { AnalyticsVendor } from "./v4_analytics";

const vendor: AnalyticsVendor = {
    id: "system:ticketmachine",

    strictlyRequired: true,
    inInitialActivations: true,

    describe: () => ({
        name: tr("cookie-law.vendors.systems.ticketmachine.name"),
        description: tr("cookie-law.vendors.systems.ticketmachine.description"),

        actualFeatures: [0],
        actualSpecialFeatures: [],
        actualPurposes: [],
        actualSpecialPurposes: [],

        policyUrl: "/privacy",
        deviceDisclosureUrl: null,
    }),

    build: () => ({
        async initialize() {},
        async event() {},
        async close() {},
        async reload() {}
    })
}

export default vendor;
